import {ToggleButtonGroup, ToggleButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';

interface SceneButtonExtended {
  children: React.ReactNode
  value?: boolean
  defaultValue?: any
  label?: string
  id?: any
  onChange?: (value: any) => void;
}

export const SceneButtonExtended = ({ children, value, defaultValue, label='', id, onChange }: SceneButtonExtended) => {
  const { t } = useTranslation()
  return (
        <ToggleButtonGroup
          color="primary"
          value={value}
          exclusive
          onChange={onChange}
          style={{
            flex: '1 1 30%',
            marginBottom: '9px',
          }}
          
        >
          <ToggleButton
            value={value}
            aria-label={label}
            style={{
              marginLeft: '11px',
              padding: '5px 12px',
            }}
            id={id}
          >
               {children}
          </ToggleButton>
        </ToggleButtonGroup>
  )
}
